import { createFileRoute } from "@tanstack/react-router";
import LandingPage from "@/pages/LandingPage";
import { landingPages } from "@/data/landingPages";
import { faqSchema, FOUNDER, pageHead, SITE_URL } from "@/lib/seo";

const c = landingPages["directeur-digital-externalise"]!.fr;
const PATH = "/directeur-digital-externalise";

export const Route = createFileRoute("/directeur-digital-externalise")({
  head: () =>
    pageHead({
      path: PATH,
      title: c.title,
      description: c.description,
      enPath: null,
      crumbs: [["Directeur digital externalisé", PATH]],
      schemas: [
        {
          "@context": "https://schema.org",
          "@type": "Service",
          name: "Directeur digital externalisé",
          serviceType: "Directeur digital externalisé",
          alternateName: ["Fractional CDO", "Chief Digital Officer externalisé", "Directrice digitale externalisée"],
          description: c.description,
          url: `${SITE_URL}${PATH}`,
          provider: { "@type": "Organization", name: "CMO Partner", url: SITE_URL, founder: FOUNDER },
          areaServed: [
            { "@type": "City", name: "Bordeaux" },
            { "@type": "AdministrativeArea", name: "Gironde" },
            { "@type": "AdministrativeArea", name: "Nouvelle-Aquitaine" },
            { "@type": "Country", name: "France" },
          ],
        },
        faqSchema(c.faq),
      ],
    }),
  component: () => <LandingPage pageKey="directeur-digital-externalise" forceLanguage="fr" />,
});
